import styled from 'styled-components';
export const LayoutContainer = styled.main`
    @import url('https://fonts.googleapis.com/css?family=Montserrat&display=swap');
    font-family: 'Montserrat', sans-serif;
    max-width: 100vw;
    widows: 100%;
    overflow-x: hidden;
    overflow-y: hidden;
    
`